var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeightreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.49996.666687c-1.46489 0-2.66667 1.201773-2.66667 2.666663h-1.33333c-.332 0-.61282.24362-.66016.57162l-1.33333 9.33333c-.02733.1913.02958.3853.15625.5313s.31057.2304.50391.2304h10.66667c.1933 0 .3772-.0844.5039-.2304s.1823-.34.1549-.5313l-1.332-9.33333c-.0473-.328-.3281-.57162-.6601-.57162h-1.3334c0-1.46489-1.20175-2.666663-2.66664-2.666663zm0 1.333333c.74444 0 1.33333.58889 1.33333 1.33333h-2.66666c0-.74444.58889-1.33333 1.33333-1.33333z",
    fill: "currentColor"
  })));
}
export default SvgWeightreact;